import React from "react";
import{Button, Drawer, Typography} from "@material-tailwind/react";


export default function AppDrawer({open, onClose, title, children}){
    return(
        <Drawer
            open={open}
            onClose={onClose}
            placement="left"
            className="p-4 pt-[100px] flex flex-col "
        >
            <div>
                <Typography className="text-xl font-semibold text-center">{title}</Typography>
            </div>

            <div className="flex-1 overflow-y-auto">
                {children}
            </div>

            <div className="flex justify-center mb-2">
                <Button
                    type= "button"
                    onClick={onClose}
                    className="
                        btn btn--secondary
                        hover:bg-gray-100
                        px-4 py-2
                        rounded-md
                        transition"
                >
                Close
                </Button>
            </div>
        </Drawer>
    );
}
